import {
  BEIAN_TEXT,
  BEIAN_URL,
  COMPANY_NAME,
  COMPANY_ADDRESS,
  COMPANY_PHONE,
  COMPANY_EMAIL,
  COMPANY_MAP_URL,
  PRODUCT_LIST,
} from "appLauncher";
import styled from "styled-components";

const FooterWrapper = styled.footer`
  width: 100%;
  background: #071843;
  color: #888;
  padding: 32px 0 0 0;
  font-size: 14px;
`;
const Copyright = styled.div`
  width: 100%;
  border-top: 1px solid #222f4a;
  color: #888;
  text-align: center;
  padding: 16px 0 8px 0;
  font-size: 13px;
  background: #071843;
`;

const FooterContent = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;
  flex-wrap: wrap;
`;

const FooterColumns = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-start;
  gap: 64px;
  flex-wrap: wrap;
`;

const FooterCol = styled.div`
  min-width: 120px;
`;

const FooterColTitle = styled.div`
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
`;

const FooterColItem = styled.div`
  color: #7a7a7a;
  font-size: 14px;
  margin-bottom: 8px;
  line-height: 1.8;
`;

const FooterLogo = styled.div`
  width: 260px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

const FooterQr = styled.div`
  width: 100px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const FooterLink = styled.a`
  color: #7a7a7a;
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.2s;
  &:hover,
  &:focus {
    color: #004cff;
    text-decoration: underline;
  }
`;

export default function Footer() {
  return (
    <FooterWrapper>
      <FooterContent>
        <FooterLogo>
          <div
            style={{
              width: 260,
              height: 80,
              backgroundImage: "url(/assets/home/white-logo.png)",
              borderRadius: 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#b0b0b0",
              fontSize: 20,
            }}
          ></div>
        </FooterLogo>
        <FooterColumns>
          <FooterCol>
            <FooterColTitle>产品</FooterColTitle>
            <div style={{ display: "flex", gap: 32 }}>
              {PRODUCT_LIST.map((group, i) => (
                <div key={i}>
                  {group.map((name) => (
                    <FooterColItem key={name}>{name}</FooterColItem>
                  ))}
                </div>
              ))}
            </div>
          </FooterCol>
          <FooterCol>
            <FooterColTitle>联系我们</FooterColTitle>
            <FooterColItem>{COMPANY_NAME}</FooterColItem>
            <FooterColItem>
              <span>地址：</span>
              <FooterLink
                href={COMPANY_MAP_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {COMPANY_ADDRESS}
              </FooterLink>
            </FooterColItem>
            <FooterColItem>
              <span>电话：</span>
              <FooterLink href={`tel:${COMPANY_PHONE}`}>
                {COMPANY_PHONE}
              </FooterLink>
              <span style={{ display: "inline-block", width: 32 }}></span>
              <span>邮箱：</span>
              <FooterLink href={`mailto:${COMPANY_EMAIL}`}>
                {COMPANY_EMAIL}
              </FooterLink>
            </FooterColItem>
          </FooterCol>
        </FooterColumns>
        <FooterQr>
          {/* 78x78二维码占位图 */}
          <div
            style={{
              width: 78,
              height: 78,
              backgroundColor: "#FFF",
              backgroundImage: "url(/assets/qrcode.png)",
              backgroundSize: "92%",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#b0b0b0",
              fontSize: 14,
            }}
          ></div>
        </FooterQr>
      </FooterContent>
      <Copyright>
        {`© ${new Date().getFullYear()}  ${COMPANY_NAME} 版权所有`}
        <br />
        <a
          href={BEIAN_URL}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#7a7a7a", textDecoration: "none", marginTop: 4 }}
        >
          {BEIAN_TEXT}
        </a>
      </Copyright>
    </FooterWrapper>
  );
}
